<kendo-appbar position="top" [positionMode]="'sticky'" [ngStyle]="headerStyle" class="idocs-appbar">
  <kendo-appbar-section>
    <!-- <button kendoButton [svgIcon]="icons.menuIcon" fillMode="flat" (click)="drawerAction($event)"></button> -->
  </kendo-appbar-section>
  <kendo-appbar-section class="title">
    <a routerLink="../home" (click)="navigate('icon-clicked')">
      <img src="/assets/img/iDocsXDPortal.png" width="50%" alt="iDocs Portal Logo">
    </a>
  </kendo-appbar-section>
  <kendo-appbar-spacer [width]="'70px'">
  </kendo-appbar-spacer>
  <kendo-appbar-section>
  </kendo-appbar-section>
  <kendo-appbar-spacer>
  </kendo-appbar-spacer>
  <!-- <span> Version: {{version}}</span> -->
  <kendo-appbar-section *ngIf="getEmailConfirmation()">
    <kendo-switch title="Admin Toggle" [(ngModel)]="userType" (ngModelChange)="setToggle()"> </kendo-switch>
  </kendo-appbar-section>
  <kendo-appbar-section (click)="refreshCurrentTab('refresh')" class="actions" *ngIf="url != 'home' && url != 'upload' && url != 'admin'">
    <button #refreshbutton kendoButton class="allbuttons" [disabled]="false"
      [svgIcon]="icons.refreshIcon">
      Refresh
    </button>
  </kendo-appbar-section>
  <kendo-appbar-section>
    @if (!loginDisplay) {
    <button #logoutbutton kendoButton [svgIcon]="icons.login" (click)="loginRedirect()">
      Login
    </button>
    }
    @if (loginDisplay) {
    <kendo-splitbutton (buttonClick)="splitButtonClick($event)" [data]="signedInButtonData"
      [svgIcon]="icons.profileUser">
      {{signedInUser()}}
    </kendo-splitbutton>
    }
  </kendo-appbar-section>
  <div class="some-spacing"></div>
</kendo-appbar>